import React from 'react';

import { Edit, useRecordContext } from 'react-admin';
import EditFormProgram from './EditFormProgram';

// Wrapper component to provide record from context to class component
const EditFormProgramWrapper = ({ permissions }) => {
  const record = useRecordContext();
  return <EditFormProgram permissions={permissions} record={record} />;
};

const EditProgram = (props) => {
  return (
    <Edit {...props}>
      <EditFormProgramWrapper permissions={props.permissions} />
    </Edit>
  );
};

export default EditProgram;
